import type { ReactNode } from 'react';
import { LayoutProvider, useLayoutSlots } from './layoutContext';
import { IconRail } from './IconRail';
import { useAppStore } from '@app/store/useAppStore';
import { useKey } from '@app/hooks/useKey';
import styles from './DesktopWorkshop.module.css';

function Body({ children }: { children: ReactNode }) {
  const { center, right } = useLayoutSlots();
  const keyId = useAppStore((s) => s.selectedKeyId);
  const key = useKey(keyId);

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <span className={styles.brand}>Fretnaught</span>
        <span className={styles.pill}>{key ? key.displayName : 'No key selected'}</span>
      </header>
      <div className={styles.body}>
        <IconRail />
        <section className={styles.center} data-scroll-surface>
          {center}
        </section>
        {right != null && (
          <section className={styles.right} data-scroll-surface>
            {right}
          </section>
        )}
      </div>
      <div hidden>{children}</div>
    </div>
  );
}

export function DesktopWorkshop({ children }: { children: ReactNode }) {
  return (
    <LayoutProvider>
      <Body>{children}</Body>
    </LayoutProvider>
  );
}
